import React from 'react';
import PropTypes from 'prop-types';
import MaterialAutoComplete from 'material-ui/AutoComplete';

import { colors } from 'styles/provider';

const AutoComplete = ({ onChange, filter = MaterialAutoComplete.fuzzyFilter, ...other }) => (
  <MaterialAutoComplete
    onNewRequest={(selection, i) => onChange(selection)}
    filter={filter}
    hintStyle={{ color: colors.clrLabelLight, fontStyle: 'italic' }}
    {...other}
  />
);

AutoComplete.propTypes = {
  onChange: PropTypes.func,
  filter: PropTypes.func,
};

export default AutoComplete;
